import React from 'react'
import { Text, Anchor, Skeleton, IconCaretDown, csx } from '@vtex/admin-ui'
import { Installment } from '@/checkout-instore-legacy/product/typings'
import { useIntl } from '@/checkout-instore-legacy/hooks/intl'
import { formatPrice } from '@/checkout-instore-legacy/utils/ProductUtils'
import { last } from 'ramda'
import { FormattedMessage } from 'react-intl'

type Props = {
  onClick: () => void
  installments: Installment[] | undefined
  isLoading: boolean
}

export const InstallmentsText = (props: Props) => {
  const intl = useIntl()

  if (props.isLoading) {
    return (
      <Skeleton
        data-testid="installments-text-loading"
        className={csx({ width: '9.375rem', height: '0.625rem' })}
      />
    )
  }

  if (!props.installments?.length) {
    return null
  }

  const installmentWithMostOptions = props.installments.reduce(
    (acc, currentInstallment) => {
      if (currentInstallment.options.length > acc.options.length) {
        return currentInstallment
      }

      return acc
    },
    props.installments[0]
  )

  const lastInstallmentOption = last(installmentWithMostOptions.options) ?? {
    value: 0,
    quantity: 0,
  }
  const minimumInstallmentValue = formatPrice(
    lastInstallmentOption.value / 100,
    intl
  )
  const maxOptionsQuantity = lastInstallmentOption.quantity

  const hasInterestRate = installmentWithMostOptions.options.some(
    (option) => option.interestRate > 0
  )
  const feeText = hasInterestRate
    ? ''
    : intl.formatMessage({ id: 'interestFree' }).toLowerCase()

  return (
    <Text
      data-testid="installments-text"
      variant="action2"
      onClick={props.onClick}
      className={csx({ cursor: 'pointer', margin: '$space-0' })}
    >
      {`${intl.formatMessage({ id: 'installmentsText' }).toLowerCase()} `}
      <Anchor
        className={csx({
          display: 'inline-flex',
          alignItems: 'center',
        })}
      >
        <Text variant="action1">
          <FormattedMessage
            id="ofInstallments"
            values={{
              maxOptionsQuantity: maxOptionsQuantity,
              minimumInstallmentValue: minimumInstallmentValue,
            }}
          />
          {` ${feeText}`}
        </Text>
        <IconCaretDown
          size="small"
          className={csx({ color: '$black', marginLeft: '$space-1' })}
        />
      </Anchor>
    </Text>
  )
}
